import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import i18n from './i18n'
import store from './store'

Vue.config.productionTip = false
router.beforeEach((to, _, next) => {
  // eslint-disable-next-line eqeqeq
  if (localStorage.length > 1 || to.name == 'Login') {
    // eslint-disable-next-line eqeqeq
    if (localStorage.length > 1 && to.name == 'Login') {
      next('/checkout')
    }
    next()
  } else {
    next('/')
  }
})
new Vue({
  vuetify,
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
